import Vue, { createApp } from 'vue'

import store from './store/index'
import { Amplify, Auth, API, Logger } from 'aws-amplify'
import mitt from 'mitt'
import VueNextSelect from 'vue-next-select'
import VueMobileDetection from 'vue-mobile-detection'
import PrimeVue from 'primevue/config'
import DialogService from 'primevue/dialogservice'
import StyleClass from 'primevue/styleclass'
import Tooltip from 'primevue/tooltip'
import 'primevue/resources/themes/aura-light-green/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import ToastService from 'primevue/toastservice'
import { i18n } from '@/plugins/i18n'
import App from './App.vue'
import cookieconfig from './plugins/cookies'
import awsconfig from './aws-exports'
import { initFacebookSdk, jwtInterceptor, fakeBackend } from './_helpers'

import router from './router'
import { useDevice } from './utils/useDevice'
;/ eslint-disable /

fakeBackend()
// enable interceptors for http requests
jwtInterceptor()
// wait for facebook sdk to start app
initFacebookSdk().then(createApp)

let output = {}
output = jsonConcat(output, awsconfig)
output = jsonConcat(output, cookieconfig)

Amplify.configure(output)

router.beforeEach(async (to, from, next) => {
	const supportedLocales = ['en', 'es', 'ar', 'jp', 'zh', 'pt', 'ko']

	if (!supportedLocales.includes(to.params.locale)) {
		const userLang = localStorage.getItem('language') || 'en'
		return next({
			path: `/${userLang}${to.fullPath}`,
			query: to.query,
			hash: to.hash,
		})
	}

	const localStorageLang = localStorage.getItem('language') || 'en'
	const localeFromUrl = to.params.locale
	const finalLocale = supportedLocales.includes(localeFromUrl)
		? localeFromUrl
		: localStorageLang

	i18n.global.locale = finalLocale
	localStorage.setItem('language', finalLocale)

	if (!localeFromUrl && !to.path.startsWith(`/${finalLocale}`)) {
		return next({
			path: `/${finalLocale}${to.fullPath}`,
			query: to.query,
			hash: to.hash,
		})
	}

	if (to.matched.length === 0) {
		return next({ name: 'NotFound' })
	}

	const publicPaths = [
		'/login',
		'/login_ib_portal',
		'/forgot',
		'/reset-password',
		'/register',
		'/register_ib_portal',
	]
	const isPublicRoute = publicPaths.some((path) => to.path.includes(path))

	try {
		if (!isPublicRoute) {
			await Auth.currentAuthenticatedUser()
		}
		next()
	} catch (error) {
		if (!isPublicRoute) {
			return next({ path: `/${finalLocale}/login` })
		}
		next()
	}
})

Logger.LOG_LEVEL = 'ERROR'

const emitter = mitt()
const app = createApp(App)

app.use(router)
app.use(store)
app.use(i18n)
app.use(Auth)
app.use(API)
app.use(VueMobileDetection)
app.use(PrimeVue)

app.use(DialogService)
app.directive('tooltip', Tooltip)
app.directive('styleclass', StyleClass)
app.use(ToastService)
app.component('VueSelect', VueNextSelect)

app.config.devtools = false

app.config.errorHandler = () => null
app.config.warnHandler = () => null

app.config.globalProperties.emitter = emitter
app.config.globalProperties.$useDevice = useDevice
app.mount('#app')

function jsonConcat(o1, o2) {
	for (const key in o2) {
		o1[key] = o2[key]
	}
	return o1
}
